module.exports = __webpack_public_path__ + "static/media/sf-test-13.74f9eb23.mp3";